import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import Alert from 'components/new_ui/Alerts/alert';

import {
  Formik,
  Form as FormikForm,
} from 'formik';

import * as Yup from 'yup';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';

export default function Form({ addCoach }) {
  const formSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    if (addCoach(values)) {
      resetForm();
    } else {
      Alert({
        title: 'Add Coach',
        text: 'A coach with this email address has already been added to the list.',
        confirmButtonText: 'Close',
      });
    }
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        firstName: '', lastName: '', email: '',
      }}
      onSubmit={onSubmitHundler}
    >
      <FormikForm className="needs-validation" noValidate="">
        <HorizontalTextField name="firstName" label="First Name" placeholder="First Name" required />
        <HorizontalTextField name="lastName" label="Last Name" placeholder="Last Name" required />
        <HorizontalTextField name="email" type="email" label="Email" placeholder="Email" required />

        <div className="mt-4 text-end">
          <Button
            type="submit"
          >
            Add To Coach List
          </Button>
        </div>
      </FormikForm>
    </Formik>
  );
}

Form.propTypes = {
  addCoach: PropTypes.func.isRequired,
};
